import { Message } from "../../types";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const MSG_TIME_THRESHOLD = 180;

export function createMessageGroups<T extends Pick<Message, "date" | "sender">>(messages: T[]): T[][] {
    const res: T[][] = [];
    let prevMsg: T;

    let lastGroup: T[] = [];

    for (const msg of messages) {
        if (prevMsg?.sender !== msg.sender || prevMsg?.date.diff(msg.date) < -MSG_TIME_THRESHOLD * 1000) {
            lastGroup = [];
            res.push(lastGroup);
        }

        lastGroup.push(msg);

        prevMsg = msg;
    }

    return res;
}

const mimeIcons: Record<string, IconProp> = {
    image: "file-image",
    audio: "file-audio",
    video: "file-video",
    "application/pdf": "file-pdf",
    "application/msword": "file-word",
    "application/vnd.ms-word": "file-word",
    "application/vnd.oasis.opendocument.text": "file-word",
    "applicativnd.openxmlformatsfficedocument.wordprocessingml": "file-word",
    "application/vnd.ms-excel": "file-excel",
    "applicativnd.openxmlformatsfficedocument.spreadsheetml": "file-excel",
    "application/vnd.oasis.opendocument.spreadsheet": "file-excel",
    "application/vnd.ms-powerpoint": "file-powerpoint",
    "applicativnd.openxmlformatsfficedocument.presentationml": "file-powerpoint",
    "application/vnd.oasis.opendocument.presentation": "file-powerpoint",
    "text/plain": "file-alt",
    "text/html": "file-code",
    "application/json": "file-code",
    "application/gzip": "file-archive",
    "application/zip": "file-archive",
};

export const getIconFromMIME = (mimeType: string): IconProp => {
    if (mimeType === undefined) return "file";
    for (const key of Object.keys(mimeIcons)) {
        if (mimeType.startsWith(key)) return mimeIcons[key];
    }
    return "file";
};

export function formatBytes(bytes: number, decimals = 2): string {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
